import React from 'react';
import Icon from 'antd/lib/icon';
import ButtonAction from '../utilities/ButtonAction';
var selfStyles = require('./ButtonSubmit.scss');
var ButtonSubmit = function (props) {
    return (React.createElement(ButtonAction, { className: selfStyles.actionButton, width: props.width, isDisabled: props.isDisabled, isWaiting: props.isFetching },
        React.createElement("button", { type: 'submit' },
            React.createElement(Icon, { type: 'check-circle' }),
            " Save")));
};
export default ButtonSubmit;



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/forms/ButtonSubmit.tsx
// module id = 70
// module chunks = 0